import { useState } from "react";
import { CalendarCheck, X } from "lucide-react";
import { useLang } from "@/i18n";
import { scrollToSection } from "./scroll";

/* Bandeau d'ouverture des réservations pour la saison 2026-2027. */
export default function SeasonBanner() {
  const { lang } = useLang();
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  return (
    <aside className="bg-gold text-night" data-testid="season-banner">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-10 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
        <div className="flex items-start gap-3 flex-1">
          <CalendarCheck
            size={18}
            strokeWidth={2.5}
            className="shrink-0 mt-0.5"
            aria-hidden="true"
          />
          <p className="font-mono text-[0.68rem] uppercase tracking-[0.12em] font-semibold leading-relaxed">
            {lang === "fr" ? (
              <>
                Réservations ouvertes pour la saison 2026-2027 — réservez en
                direct, sans commission
              </>
            ) : (
              <>
                Now booking the 2026-2027 season — reserve direct,
                commission-free
              </>
            )}
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0 sm:pl-4">
          <button
            type="button"
            onClick={() => scrollToSection("reservations")}
            data-testid="season-banner-cta"
            className="border border-night/60 px-4 py-2.5 font-mono text-[0.6rem] uppercase tracking-[0.15em] font-semibold hover:bg-night hover:text-gold transition-colors duration-300"
          >
            {lang === "fr" ? "Voir les disponibilités" : "See availability"}
          </button>
          <button
            type="button"
            onClick={() => setVisible(false)}
            aria-label={lang === "fr" ? "Fermer" : "Close"}
            data-testid="season-banner-dismiss"
            className="p-1.5 opacity-60 hover:opacity-100 transition-opacity duration-200"
          >
            <X size={16} aria-hidden="true" />
          </button>
        </div>
      </div>
    </aside>
  );
}
